import ReactDOM from 'react-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { store } from './store/store'

// Handle stale-deployment preload failures (CSS & JS).
// Vite 5+ fires this event when any modulepreload or CSS preload 404s.
window.addEventListener('vite:preloadError', event => {
  const key = 'hasReloadedForPreloadError'
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, 'true')
    window.location.reload(true)
  }
  event.preventDefault()
})

async function init() {
  ;(async () => {
    // Load the client checks (expects a setPreventLoad callback)
    const { default: checkClientSupport } = await import(
      '@util/checkClientSupport'
    )

    // Track whether we should halt normal startup
    let preventLoad = false
    const setPreventLoad = v => {
      preventLoad = v
    }

    // This will synchronously set preventLoad = true if WebGL/localStorage fail,
    // and it will also dispatch the proper modal content to Redux.
    checkClientSupport({ setPreventLoad })

    const container = document.getElementById('root')

    if (preventLoad) {
      // Mount just enough UI so the already-dispatched modal can render.
      const { default: Modal } = await import('@components/Shared/Modal')

      ReactDOM.render(
        <ReduxProvider store={store}>
          <Modal />
        </ReduxProvider>,
        container
      )
      return
    }

    // Normal app startup
    const { default: bootstrap } = await import('./bootstrap')
    bootstrap()
  })()
}

init()
